import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPause = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.5 2.5C8.5 1.67157 7.82843 1 7 1H5.5C4.67157 1 4 1.67157 4 2.5V17.5C4 18.3284 4.67157 19 5.5 19H7C7.82843 19 8.5 18.3284 8.5 17.5V2.5Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16 2.5C16 1.67157 15.3284 1 14.5 1H13C12.1716 1 11.5 1.67157 11.5 2.5V17.5C11.5 18.3284 12.1716 19 13 19H14.5C15.3284 19 16 18.3284 16 17.5V2.5Z",
		fill: "white"
	})]
});
export default SvgPause;
